import { render } from "./ConfigurationSettings.vue?vue&type=template&id=16b36de7&scoped=true"
import script from "./ConfigurationSettings.vue?vue&type=script&lang=js"
export * from "./ConfigurationSettings.vue?vue&type=script&lang=js"

import "./ConfigurationSettings.vue?vue&type=style&index=0&id=16b36de7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b36de7"]])

export default __exports__